var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500781,
    y: 0.500781,
    width: 53.9984,
    height: 53.9984,
    stroke: "black",
    strokeWidth: 1.00156
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0097 25.3302C22.7852 21.9438 27.9688 19.7093 30.5606 18.6321C37.968 15.5496 39.5039 15.0163 40.5065 15.0003C40.7252 14.995 41.2211 15.0537 41.5411 15.3096C41.8131 15.5283 41.8877 15.8216 41.9197 16.0296C41.9517 16.2376 41.9997 16.7122 41.9624 17.0802C41.5624 21.2985 39.8239 31.5271 38.944 36.2521C38.5707 38.2519 37.8347 38.9186 37.1201 38.9879C35.5735 39.1319 34.395 37.964 32.8964 36.9827C30.5499 35.4468 29.222 34.4869 26.9448 32.983C24.3104 31.2498 26.0169 30.2952 27.5208 28.738C27.9154 28.3327 34.7363 22.1251 34.8696 21.5598C34.8856 21.4905 34.9016 21.2292 34.7469 21.0905C34.5923 20.9519 34.363 20.9999 34.1923 21.0372C33.9577 21.0905 30.2086 23.5704 22.9451 28.4713C21.8786 29.2019 20.9186 29.5592 20.0547 29.5379C19.1001 29.5166 17.2709 28.9993 15.911 28.5567C14.2418 28.0127 12.9139 27.7247 13.0312 26.8075C13.0899 26.3222 13.7512 25.8315 15.0097 25.3302Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.0806ba35d535d506accb6f6aa60874ff.svg";
export { ForwardRef as ReactComponent };